import {
    setItemBySession,
    itemType
} from 'MMT-UI/storages/client/sessionStorage';

export const setItemIntoSession = async (key: string, value: string) => {
    try {
        await setItemBySession(
            key,
            value,
            { shouldStringifyJson: true, isPiiData: true },
            itemType.ES
        );
    } catch (error) {
        console.error('Error in setting item into session', error);
    }
}
